import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["serverRequest"];
import appConfig from '@nerdwallet/app-config';
import initNwApiSdk from '@nerdwallet/nw-api-sdk';
import { ClientContext } from '@nerdwallet/structured-content-core';
import createNerdwalletClient from './create-client';
import StructuredContentWithClearfix from './structured-content';
import StructuredContentProviderWithNavigationContextProvider from './structured-content-provider'; // create an nw-api-sdk instance for providers
// TODO: maybe instantiate this in separate file?

var nwApiSdk = initNwApiSdk({
  applicationID: appConfig.APP_ID,
  clientID: appConfig.CLIENT_ID,
  cookieDomain: appConfig.COOKIE_DOMAIN,
  identityBaseUrl: appConfig.IDENTITY_BASE_URL
});
export default StructuredContentWithClearfix;
var StructuredContentProvider = StructuredContentProviderWithNavigationContextProvider;
export { StructuredContentProvider }; // create nerdwallet client and give it appConfigs and nwApiSdk instance

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      serverRequest = _ref.serverRequest,
      options = _objectWithoutProperties(_ref, _excluded);

  return createNerdwalletClient(_objectSpread({
    serverRequest: serverRequest,
    nwApiSdk: nwApiSdk,
    appConfig: appConfig
  }, options));
};

export { createClient };
export { ClientContext };